<template>
    <!-- <layout-portal> -->
    <div class="container maintenancement">
        <div class="row">
            <div class="col-12 text-center mt-3">
                <img alt="error-503" class="maintenancement--image" :src="assetsPathModule('/error503.png')" />
                <h1 class="maintenancement--title mb-3 mb-sm-5">Serviço em manutenção</h1>
                <h2 class="maintenancement--text">
                    Estamos a trabalhar para si. <br>
                    Prometemos ser breves
                </h2>
                <a @click.prevent="goHome()" href="/" class="btn btn-dark mt-3 mt-sm-4">Home</a>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center py-3">
                <div class="maintenancement--footer">
                    <a @click.prevent="goHome()" href="/">
                        <img :src="assetsPathGlobalPlatform('/logo-header.svg')" />
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- </layout-portal> -->
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        name: 'PageMaintenancement503',
        mixins: [GlobalMixin],
        data() {
            return {
                moduleCode: 'portal',
            }
        },
        methods: {
            goHome() {
                document.location.href = "/";
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "@styles/_theme.scss";
    @import "@styles/_mixins.scss";
    .maintenancement {
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        & &--image {
            max-width: 80%;

        }
        & &--text {
            font-family: $city-light-font-family;
        }
        & &--footer {
            img {
                max-width: 100%;
            }
        }
    }
</style>